import { effect, EnvironmentProviders, inject, Injector, provideEnvironmentInitializer, untracked } from '@angular/core';
import { ApplicationContextStore } from '../application-context/application-context.store';
import { TokenService } from '../token-service/token.service';
import { TranslationService } from './translation.service';

/**
 * Refreshes the translation dictionary once at app start when a session already exists, so tenant
 * wording overrides saved since the user last signed in take effect on the next app open without a
 * fresh sign-in. It waits for the application context to finish hydrating because that step can
 * replace the selected language, and fetching before it would cache the wrong language. Fresh
 * sign-ins are left to the login flow, which already fetches the dictionary.
 */
export function provideDictionaryRefreshOnStart(): EnvironmentProviders {
    return provideEnvironmentInitializer(() => {
        const applicationContext = inject(ApplicationContextStore);
        const tokenService = inject(TokenService);
        const translationService = inject(TranslationService);
        const injector = inject(Injector);

        const ref = effect(
            () => {
                if (!applicationContext.isReady()) {
                    return;
                }
                ref.destroy();
                untracked(() => {
                    if (tokenService.getToken()) {
                        translationService.refreshDictionary().subscribe();
                    }
                });
            },
            { injector },
        );
    });
}
